// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function TimeClocksRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (!state.productHasTimeClocks) return <></>

   return (
      <div className='row'>
         <div className='col-bhr1'>
            {getString('product.TimeClocksRow.ProductName')}
         </div>
         <div className='col-bhr2'></div>
         <div className='col'></div>
         <div className='col'></div>
         <div className='col'></div>
         <div className='col'>
            {formatFloatAsCurrencySymbol(
               state.TimeClockCosts.reduce(
                  (acc, item) => acc + item.totalPrice,
                  0,
               ),
               state.currencyObject,
            )}
         </div>
         {state.differenceQuote == true ? (
            <>
               <div className='col'></div>
               <div className='col'></div>
            </>
         ) : (
            <></>
         )}
      </div>
   )
}
